/* v8 ignore start */
import {BaseCollection} from "@/lib/core/collection/base/baseCollection";

export class Collection<T> extends BaseCollection<T> {
  protected subset(items: T[]): this {
    return new Collection(items) as this;
  }

  protected resolve(item: T): T {
    return item;
  }
}
/* v8 ignore stop */
